import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Newspaper, Calendar, Archive, FileText, ArrowRight } from 'lucide-react';
import '../admin/admin_dashboard.css'; // 🟢 Reusing the exact dashboard & panel styling asset

const AdminContentDashboard = () => {
  const navigate = useNavigate();

  const modules = [
    {
      title: "News Update",
      desc: "Publish and manage current organization headlines, press releases, and announcements.",
      icon: <Newspaper size={28} />,
      path: "/admin-parm/content-dashboard-parm/news/new"
    },
    {
      title: "Event Update",
      desc: "Schedule upcoming conferences, webinars, workshops, and manage attendee registrations.",
      icon: <Calendar size={28} />,
      path: "/admin-parm/content-dashboard-parm/events/new"
    },
    {
      title: "News Draft",
      desc: "Edit and update saved draft articles before publishing live.",
      icon: <FileText size={28} />,
      path: "/admin-parm/content-manage-parm/news"
    },
    {
      title: "Event Draft",
      desc: "Edit and update saved draft events before publishing live.",
      icon: <FileText size={28} />,
      path: "/admin-parm/content-manage-parm/event"
    },
    {
      title: "News Archive",
      desc: "Review historical announcements, past newsletters, and legacy media logs.",
      icon: <Archive size={28} />,
      path: "/archive-news-list-parm"
    },
    {
      title: "Event Archive",
      desc: "Access historical conference logs, previous event proceedings, and past program files.",
      icon: <Archive size={28} />,
      path: "/archive-event-list-parm"
    }
  ];

  return (
    <section className="admin-dashboard-section">
      <div className="admin-dashboard-container">
        
        {/* Header Block matching your exact text hierarchy styles */}
        <header className="admin-dashboard-header">
          <span>MODULES</span>
          <h2>Content Management</h2>
          <p>Create, update, and manage public resources, news feeds, and conference records.</p>
        </header>

        {/* 🟢 Reusing the exact grid container from your stylesheet */}
        <div className="admin-menu-grid">
          {modules.map((mod, idx) => (
            <div 
              key={idx} 
              className="admin-menu-card"
              onClick={() => navigate(mod.path)}
            >
              {/* Icon Shell that flips background color on hover */}
              <div className="admin-icon-wrapper">
                {mod.icon}
              </div>
              
              {/* Card content structure */}
              <div className="admin-card-info">
                <h3>{mod.title}</h3>
                <p>{mod.desc}</p>
              </div>

              {/* Interactive Footer Indicator mimicking your dashboard cards */}
              <div className="admin-card-footer">
                <span>Enter Module</span>
                <ArrowRight size={16} style={{ marginLeft: '8px' }} />
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AdminContentDashboard;